import * as React from "react";

import errorImage from "common/assets/images/errorPic-min.png";

import Card from "features/common/components/Card";

import "./GeneralAppError.scss";

type GeneralErrorProps = {
  tryAgainLink: string;
};

// TODO: refactor
const GeneralAppError = ({ tryAgainLink }: GeneralErrorProps) => {
  return (
    <CommonAppError tryAgainLink={tryAgainLink}>
      <div className="ErrorScreen__textblock">
        <div className="ErrorScreen__bottomtext ErrorScreen__text">
          If you are working at school this is probably due to your school
          network blocking some of the things Seneca needs to work.{" "}
          <a
            href={
              "https://help.senecalearning.com/it-troubleshooting/how-do-i-unblock-seneca-on-my-school-network"
            }
            target="_blank"
            rel="noopener noreferrer"
            className="ErrorScreen__link"
          >
            Share this link
          </a>{" "}
          with an IT technician at your school to help them fix it.
        </div>
      </div>
    </CommonAppError>
  );
};

type CommonErrorProps = {
  tryAgainLink?: string;
  children?: React.ReactNode;
};

const CommonAppError = ({ tryAgainLink, children }: CommonErrorProps) => {
  return (
    <div className="ErrorScreen__wrapper">
      <img alt="" src={errorImage} className="ErrorScreen__errorimage" />
      <div className="ErrorScreen__text">Sorry, something went wrong!</div>
      {children}
      <div className="ErrorScreen__bottomtext ErrorScreen__text">
        Please get in touch if the problem persists.
      </div>
    </div>
  );
};

export const MinimalAppError = () => {
  return <CommonAppError />;
};

export const PageNotFoundError = ({ children }: CommonErrorProps) => {
  return (
    <div className="ErrorScreen__wrapper">
      <img alt="" src={errorImage} className="ErrorScreen__errorimage" />
      <div className="ErrorScreen__text">
        Sorry, looks like that page does not exist!
      </div>
      {children}
      <div className="ErrorScreen__bottomtext ErrorScreen__text">
        Please get in touch and let us know how you got here.
      </div>
    </div>
  );
};

export const makeAppError = (tryAgainLink: string) => () =>
  <GeneralAppError tryAgainLink={tryAgainLink} />;

export default GeneralAppError;

export function GeneralAppErrorCard({ tryAgainLink }: GeneralErrorProps) {
  return (
    <Card rounded>
      <GeneralAppError tryAgainLink={tryAgainLink} />
    </Card>
  );
}
